import React from "react";
import Link from "gatsby-link";
import { Dropdown } from "semantic-ui-react";

import { baseConfig } from "../../../config/config";
import { linksOrder } from "../../../config/baseConfig";

import NavigationLink from "./NavigationLink";
import NavigationLogo from "./NavigationLogo";
import OrderButton from "./OrderButton";

const { pageMetadata } = baseConfig;

function getGroup(groupName) {
  const keys = Object.keys(pageMetadata).filter(
    key => pageMetadata[key].groupName === groupName
  );

  return keys.map(key => pageMetadata[key]);
}

const DropdownGroup = ({ group }) => {
  const { name, links } = group;

  return (
    <Dropdown text={name} className="navigation-dropdown">
      <Dropdown.Menu>
        {links.map(({ displayTitle, path }) => {
          if (path[0] !== "/") {
            return (
              <Dropdown.Item
                text={displayTitle}
                as="a"
                href={path}
                rel="noopener"
                target="_blank"
              />
            );
          }

          return <Dropdown.Item text={displayTitle} as={Link} to={path} />;
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const DesktopNavigation = ({ currentLocation }) => {
  return (
    <div className="nav-container">
      <NavigationLogo />
      <div id="nav-links">
        {linksOrder.map(({ slug, groupName }) => {
          if (groupName) {
            const group = {
              name: groupName,
              links: getGroup(groupName)
            };

            return <DropdownGroup group={group} />;
          }

          const page = pageMetadata[slug];
          return (
            <div className="nav-link" key={slug}>
              <NavigationLink
                pageMetadata={page}
                isActive={currentLocation === page.path}
                isInternal={
                  slug !== "joinus" &&
                  slug !== "ourmenu" &&
                  slug !== "allergyMenu" &&
                  slug !== "jobs" &&
                  slug !== "giftCards"
                }
              />
            </div>
          );
        })}
        {/* {pageKeys.map(pageKey => ( */}
        {/* <div className="nav-link" key={pageKey}> */}
        {/* <NavigationLink */}
        {/* pageMetadata={pageMetadata[pageKey]} */}
        {/* isActive={currentLocation === pageMetadata[pageKey].path} */}
        {/* isInternal={ */}
        {/* pageKey !== "joinus" && */}
        {/* pageKey !== "ourmenu" && */}
        {/* pageKey !== "jobs" && */}
        {/* pageKey !== "giftCards" */}
        {/* } */}
        {/* /> */}
        {/* </div> */}
        {/* ))} */}
        <OrderButton
          linkType="a"
          link="mailto:hi@wholesol.com"
          text="CONTACT US"
        />
        <OrderButton
          linkType="a"
          link="https://www.wholesolblendbar.com/s/order"
          text="ORDER PICKUP"
        />
        <OrderButton link="/locations/" text="ORDER DELIVERY" />
      </div>
    </div>
  );
};

export default DesktopNavigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/DesktopNavigation.jsx